import { ClasslessFilenameTemplateItem } from '../classes/ClasslessFilenameTemplateItem'

export const PhotoSequenceNumber = new ClasslessFilenameTemplateItem({
  id: 'd898c74d-299e-468f-ad9a-1808d667c61b',
  name: 'Photo Sequence Number',
  property: 'photoSequenceNumber',
  help: "A generated sequence number to identify a record's Media Upload",
  exampleValue: '1',
  required: true,
})

/**
 * i could add a Tag and TagCategory filename template item classes and then add
 * a bunch of scaffolding to make it work for an array of each...
 *
 * but given the fact we're moving towards handlebars and all this filename
 * template stuff is kind of janky at best -- why i didn't i look for better
 * templating tools to find handlebars back in the day i couldn't tell
 * you: probably pride -- i'm ok with just making them classless to skip all the
 * complicated stuff
 */

/** */
export const Tags = new ClasslessFilenameTemplateItem({
  id: 'fb14ff59-49d8-4069-b462-3b2abff030e0',
  name: 'Tags',
  property: 'tags',
  help: 'The first 5 characters of all active Tags, ordered alphabetically, and joined with an underscore',
  exampleValue: 'First_Secon_Third',
})

export const TagCategories = new ClasslessFilenameTemplateItem({
  id: 'b8e7b13f-3484-4943-97c2-5f7b836add3e',
  name: 'Tag Categories',
  property: 'tagCategories',
  help: 'The first 5 characters of all active Tag Categories, ordered alphabetically, and joined with an underscore',
  exampleValue: 'First_Secon_Third',
})

export type ClasslessFilename =
  | typeof PhotoSequenceNumber
  | typeof Tags
  | typeof TagCategories
